import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "menu",
      component: () => import("./components/AppContainer.vue")
    },
    {
      path: "/users",
      name: "users",
      component: () => import("./components/Users.vue"),
      beforeEnter: requireAdminRights
    },
    {
      path: "*",
      name: "badUrl",
      component: () => import("./components/404.vue")
    }
  ]
});

// If user is not admin, redirect on 404 page
function requireAdminRights(from, to, next) {
  if (store.state.user.roles && store.state.user.roles.includes("ADMIN")) {
    next()
  } else {
    next("404")
  }
}


// WEBPACK FOOTER //
// ./src/router.js